// @flow

import React from 'react';
import { Strong } from 'seek-style-guide/react';

type Props = {
  component?: string,
  title: string,
  isExpired?: boolean,
  className?: string
};

const JobTitle = ({
  component: Component = 'h1',
  isExpired,
  title,
  className
}: Props) => (
  <Component className={className}>
    {isExpired && <Strong>Expired: </Strong>}
    {title}
  </Component>
);

export default JobTitle;
